export default {
  COLLABORATOR: 'DesignPartner',
  PRO: 'Premium',
};
